import type { RealtimeMetrics } from "./metrics";
import type { AblyLogger } from "./types";

export type AblyConfig = {
	disconnectedRetryTimeout: number;
	suspendedRetryTimeout: number;
	presenceRetryDelayMs: number;
	publishRetryDelayMs: number;
	maxPublishRetries: number;
	confirmSendTimeoutMs: number;
	reconnectionPopupDurationMs: number;
	graderPollingIntervalMs: number;
	graderMaxPollingRetries: number;
	restPresencePollMs: number;
	restPresenceRecoveryPollMs: number;
};

const DEFAULT_CONFIG: AblyConfig = {
	disconnectedRetryTimeout: 1000,
	suspendedRetryTimeout: 5000,
	presenceRetryDelayMs: 2000,
	publishRetryDelayMs: 1000,
	maxPublishRetries: 5,
	confirmSendTimeoutMs: 3000,
	reconnectionPopupDurationMs: 3000,
	graderPollingIntervalMs: 5000,
	graderMaxPollingRetries: 5,
	restPresencePollMs: 3000,
	restPresenceRecoveryPollMs: 2000,
};

export let ABLY_CONFIG: AblyConfig = { ...DEFAULT_CONFIG };

type AblyRuntimeConfig = {
	logger: AblyLogger;
	metrics: RealtimeMetrics | null;
};

export const noopLogger: AblyLogger = {
	info: () => {},
	warning: () => {},
	error: () => {},
	debug: () => {},
};

let _runtimeConfig: AblyRuntimeConfig = {
	logger: noopLogger,
	metrics: null,
};

export function configureAbly(config: Partial<AblyRuntimeConfig> & Partial<AblyConfig>): void {
	const { logger, metrics, ...configOverrides } = config;

	if (logger) {
		_runtimeConfig = { ..._runtimeConfig, logger };
	}

	if (metrics !== undefined) {
		_runtimeConfig = { ..._runtimeConfig, metrics };
	}

	if (Object.keys(configOverrides).length > 0) {
		ABLY_CONFIG = { ...ABLY_CONFIG, ...configOverrides };
	}
}

export function getRuntimeConfig(): AblyRuntimeConfig {
	return _runtimeConfig;
}
